import { writable } from "svelte/store";

if (!localStorage.device_info) {
    localStorage.setItem('device_info', JSON.stringify({}));
}

export const device_info = writable(JSON.parse(localStorage.device_info));

device_info.subscribe(value => {
    localStorage.device_info = JSON.stringify(value)
});